import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import GuatemalaMission from "./pages/GuatemalaMission";
import MexicoMission from "./pages/MexicoMission";
import CubaMission from "./pages/CubaMission";
import Missions from "./pages/Missions";
import Auth from "./pages/Auth";
import AdminDashboard from "./pages/AdminDashboard";
import Announcements from "./pages/Announcements";
import Donate from "./pages/Donate";
import WomensMinistry from "./pages/ministries/WomensMinistry";
import PrayerMinistry from "./pages/ministries/PrayerMinistry";
import Sermons from "./pages/Sermons";
import SermonDetail from "./pages/SermonDetail";
import BibleStudy from "./pages/BibleStudy";
import Bible from "./pages/Bible";
import BibleSchool from "./pages/BibleSchool";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BecomeContributor from "./pages/BecomeContributor";
import DailyBibleReading from "./pages/DailyBibleReading";
import SpecialEvents from "./pages/SpecialEvents";
import MemberRegistration from "./pages/MemberRegistration";
import MemberPortal from "./pages/MemberPortal";
import Members from "./pages/Members";
import Music from "./pages/Music";
import SecurityMonitoring from "./pages/SecurityMonitoring";
import YouTubeVideos from "./pages/YouTubeVideos";
import AdminYouTubeVideos from "./pages/admin/YouTubeVideos";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/announcements" element={<Announcements />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/missions" element={<Missions />} />
              <Route path="/guatemala-mission" element={<GuatemalaMission />} />
              <Route path="/mexico-mission" element={<MexicoMission />} />
              <Route path="/cuba-mission" element={<CubaMission />} />
              <Route path="/ministries/womens-ministry" element={<WomensMinistry />} />
              <Route path="/ministries/prayer-ministry" element={<PrayerMinistry />} />
              <Route path="/sermons" element={<Sermons />} />
              <Route path="/sermons/:id" element={<SermonDetail />} />
              <Route path="/bible-study" element={<BibleStudy />} />
              <Route path="/bible" element={<Bible />} />
              <Route path="/bible-school" element={<BibleSchool />} />
              <Route path="/daily-bible-reading" element={<DailyBibleReading />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/become-contributor" element={<BecomeContributor />} />
              <Route path="/special-events" element={<SpecialEvents />} />
              <Route path="/members" element={<Members />} />
              <Route path="/member-registration" element={<MemberRegistration />} />
              <Route path="/member-portal" element={<MemberPortal />} />
              <Route path="/music" element={<Music />} />
              <Route path="/security-monitoring" element={<SecurityMonitoring />} />
              <Route path="/youtube-videos" element={<YouTubeVideos />} />
              <Route path="/admin/youtube-videos" element={<AdminYouTubeVideos />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
